import React, { useEffect, useRef } from "react";
import { createPortal } from "react-dom";

/**
 * Fereastră de confirmare a platformei (în locul ferestrei de sistem window.confirm).
 * Esc / clic în afară = anulează; Enter = confirmă (butonul are focus).
 * rows: [[eticheta, valoarea]] — rezumatul a ceea ce se confirmă.
 */
export default function ConfirmDialog({
   open,
   title,
   rows = [],
   note,
   confirmLabel = "Confirmă",
   cancelLabel = "Anulează",
   tone = "primary",
   busy = false,
   onConfirm,
   onCancel,
}) {
   const confirmRef = useRef(null);

   useEffect(() => {
      if (!open) return undefined;
      confirmRef.current?.focus();
      const onKey = (e) => {
         if (e.key !== "Escape") return;
         // Esc e al ferestrei: nu mai ajunge la pagina de dedesubt (de ex. calendarul nu renunță și la tăiere)
         e.preventDefault();
         e.stopPropagation();
         if (!busy) onCancel?.();
      };
      document.addEventListener("keydown", onKey);
      return () => document.removeEventListener("keydown", onKey);
   }, [open, busy, onCancel]);

   if (!open) return null;

   return createPortal(
      <div
         className="confirmDialog"
         role="presentation"
         onPointerDown={(e) => {
            if (e.target === e.currentTarget && !busy) onCancel?.();
         }}
      >
         <div className="confirmDialog__box" role="dialog" aria-modal="true" aria-label={title}>
            <p className="confirmDialog__title">{title}</p>
            {rows.length > 0 && (
               <dl className="confirmDialog__rows">
                  {rows.map(([label, value]) => (
                     <div key={label} className="confirmDialog__row">
                        <dt>{label}</dt>
                        <dd>{value}</dd>
                     </div>
                  ))}
               </dl>
            )}
            {note && <p className="confirmDialog__note">{note}</p>}
            <div className="confirmDialog__actions">
               <button type="button" className="confirmDialog__btn" onClick={onCancel} disabled={busy}>
                  {cancelLabel}
               </button>
               <button
                  ref={confirmRef}
                  type="button"
                  className={`confirmDialog__btn confirmDialog__btn--${tone}`}
                  onClick={onConfirm}
                  disabled={busy}
               >
                  {busy ? "Se salvează…" : confirmLabel}
               </button>
            </div>
         </div>
      </div>,
      document.body,
   );
}
